/* ------------------------------------------------
Import Modules
------------------------------------------------ */

import CharacterLimitController from "../classes/character-limits";

/* ------------------------------------------------
Document setup
------------------------------------------------ */

// Find all the character limit inputs [maxlength]
const inputs = document.querySelectorAll('.js-pardot-page [maxlength]');

// Loop through each input
inputs.forEach(input => {
  // Create a new Character Limit Controller
  new CharacterLimitController(input);
});